import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import s from '../layouts/Layout.module.scss';
export const AdminPage = (): JSX.Element => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/admin/ferdabeidnir');
  }, []);
  return (
    <div className={s.layout__content}>
      <Outlet />
    </div>
  );
};
